import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginationResult } from './pagination-result';
import { NotificationSource } from './dashboard/notification-bar/notification-bar.model';
import { Injectable } from '@angular/core';
const consentResultKeyPrefix = 'consent-result-ss-lib'

@Injectable({
  providedIn: 'root'
})
export class ConsentsService {
  private url = environment.gatewayUrl;
  constructor(private httpClient: HttpClient) { }

  getUserConsents(): Observable<PaginationResult<ConsentDto>> {
    const params = new HttpParams().set('Page', 1).set('PageSize', 50);
    return this.httpClient.post<PaginationResult<ConsentDto>>(`${this.url}consents/search`, {}, { params: params });
  }

  approve(consentId: number) {
    return this.httpClient.post(`${this.url}consents/${consentId}/approve`, {});
  }
  reject(consentId: number) {
    return this.httpClient.post(`${this.url}consents/${consentId}/reject`, {});
  }

}

export interface ConsentDto {
  id: number;
  data: ConsentDataDto
}
export interface ConsentViewModel {
  id: number;
  modules: NotificationSource[];
  htmlMessage: string;
  title?: string;
  from: Date;
  to: Date;
}
export interface ConsentDataDto {
  modules: NotificationSource[];
  htmlMessage: string;
  title?: string;
  from: Date;
  to: Date;
}